import { watchCommonAuthentication } from "../../modules/common/store/sagas";

const intialiseSagaMiddleware = (sagaMiddleware) => {
    sagaMiddleware.run(watchCommonAuthentication);
}

export default intialiseSagaMiddleware;
